const RoundedButton = (props) => {
    return (
        <button onClick={props.onClick} className='flex-1 rounded-[6.25rem]' style={{ height: props.height, backgroundColor: props.disabled ? '#E9E9E9' : props.bgColor }} disabled={props.disabled ? true : false}>
            <p className='font-montserrat font-semibold' style={{ color: props.disabled ? '#999999' : '#FFF' }}>{props.text}</p>
        </button>
    )
}

export default RoundedButton